import useAuth from './useAuth';
import { useAxiosQuery } from './useAxiosQuery';
import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { LiveUnit } from 'types';
import { canReadAsset } from 'utils/authorization';

/* Create return object of the hook */
const mapStatusWithUnitData = (units: LiveUnit[] | undefined): Record<string, boolean> => {
  const formattedData: { [key: string]: boolean } = {};
  units?.forEach((unit: LiveUnit) => {
    formattedData[unit.unitId] = unit.isConnected;
  });

  return formattedData;
};

export default function useUnitsConnectionStatus() {
  const { pathname } = useLocation();
  const { user } = useAuth();

  const { data } = useAxiosQuery<LiveUnit[]>([pathname, 'live', 'units'], '/live/units/', {
    enabled: canReadAsset(user?.role),
    cacheTime: 0,
    staleTime: 0,
    suspense: false,
  });

  const mappedData = useMemo(() => mapStatusWithUnitData(data), [data]);

  return mappedData;
}
